import { cn } from '@theprintbar/shared';
import { FacebookIcon, InstagramIcon, LinkedinIcon, PinterestIcon } from '@theprintbar/ui';
import { RootLoaderData } from '~/root';

interface SocialsProps {
	colour: 'white' | 'blue';
	data: RootLoaderData;
	className?: string;
}

export function Socials({ data, colour, className }: SocialsProps) {
	const { globalContent } = data;
	return (
		<div className={cn('flex space-x-2', className)}>
			{[
				{
					link: globalContent.instagramLink,
					Icon: InstagramIcon,
				},
				{
					link: globalContent.linkedinLink,
					Icon: LinkedinIcon,
				},
				{
					link: globalContent.facebookLink,
					Icon: FacebookIcon,
				},
			].map(({ link, Icon }) => (
				<a href={link} key={`footer-social-${link}`} target="_blank">
					<Icon className={cn('w-9 h-9', colour === 'blue' ? 'text-blue' : 'text-white')} />
				</a>
			))}
		</div>
	);
}
